import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { ArrowLeft, Home } from 'lucide-react';
import QuickActionsDashboard from '@/components/QuickActionsDashboard';
import BottomNavigation from '@/components/BottomNavigation';

const Dashboard = () => {
  const navigate = useNavigate();

  const handleGoBack = () => {
    if (window.history.length > 2) {
      navigate(-1);
    } else {
      navigate('/');
    }
  };

  return (
    <div className="min-h-screen bg-elegant pb-24">
      {/* Header */}
      <div className="sticky top-0 z-10 glass-effect border-b border-cream-300">
        <div className="px-6 py-4">
          <div className="flex items-center gap-4 mb-4">
            <Button 
              variant="ghost" 
              size="sm" 
              onClick={handleGoBack}
              className="p-2 hover:bg-cream-100 text-navy-600"
            >
              <ArrowLeft className="h-5 w-5" />
            </Button>
            <div className="flex-1">
              <h1 className="text-2xl font-serif font-semibold text-navy-800">
                Dashboard
              </h1>
              <p className="text-sm text-navy-600">
                Je persoonlijke WOM Plaza overzicht
              </p>
            </div>
            <Button 
              variant="outline"
              size="sm"
              onClick={() => navigate('/')}
              className="btn-elegant-secondary"
            >
              <Home className="h-4 w-4 mr-2" />
              Home
            </Button>
          </div>

          {/* WOM Plaza Header */}
          <div className="card-premium p-4">
            <div className="text-center">
              <div className="mb-2">
                <h1 className="text-xl font-light tracking-wider text-navy-700">
                  <span className="font-bold text-navy-800">W</span>
                  <span className="mx-1 text-gold-400">·</span>
                  <span className="font-bold text-navy-800">O</span>
                  <span className="mx-1 text-gold-400">·</span>
                  <span className="font-bold text-navy-800">M</span>
                  <span className="ml-3 font-bold text-navy-800">Dashboard</span>
                </h1>
              </div>
              <p className="text-sm text-navy-600">
                Welkom terug, woman on a mission! 🌟
              </p>
            </div>
          </div>
        </div>
      </div>

      {/* Dashboard Content */}
      <div className="px-6 py-6">
        <QuickActionsDashboard />
      </div>

      {/* Bottom Navigation */}
      <BottomNavigation />
    </div>
  );
};

export default Dashboard;